export const CALENDAR_INTEGRATION_SCROLL_ANCHOR = 'integration-calendar';
